import { jsxs as b, jsx as o } from "react/jsx-runtime";
import { useMemo as h } from "react";
import e from "./index.es801.js";
import n from "classnames";
import { useResizeObserver as y } from "@placer-ui/hooks";
import { BodyText as f } from "./index.es487.js";
const E = "similarity-bar", w = 16, C = 96, L = (s, t) => {
  const { high: a, low: i } = t, r = Number(s.replace("%", ""));
  return r > a ? "high" : r < i ? "low" : "medium";
}, P = ({
  additionalValue: s,
  levelValuePosition: t = "inside",
  thresholds: a = { high: 70, low: 40 },
  levelValue: i,
  testId: r = E,
  isWithinDataCell: l
}) => {
  const { containerRef: N, contentRect: m } = y(), c = h(() => L(i, a), [i, a]), d = Number(i.replace("%", "")), p = d > C, u = n(e.labelContainer, e[t]), v = n(e.filledPortion, e[c], {
    [e.isWithinDataCell]: l
  }), T = n(e.bar, { [e.isWithinDataCell]: l }), _ = h(() => ({
    "--labelWidth": `${m.width - w}px`
  }), [m.width]);
  return /* @__PURE__ */ b("div", { className: e.root, "data-testid": r, children: [
    /* @__PURE__ */ o(f, { variant: "bold", children: s }),
    /* @__PURE__ */ b("div", { className: T, children: [
      /* @__PURE__ */ o(
        "div",
        {
          className: v,
          style: { width: i },
          "data-testid": `${r}-filled-section`,
          role: "progressbar",
          "aria-valuenow": d,
          "aria-valuemin": 0,
          "aria-valuemax": 100,
          "aria-label": `${i} similarity`
        }
      ),
      /* @__PURE__ */ o(
        "div",
        {
          className: u,
          style: _,
          ref: N,
          "data-testid": `${r}-label-container`,
          children: /* @__PURE__ */ o(
            f,
            {
              variant: "semi-bold",
              element: "label",
              color: c === "high" && (t === "inside" || p) ? "white" : "primary",
              children: i
            }
          )
        }
      )
    ] })
  ] });
};
export {
  P as PrimitiveSimilarityBar,
  E as SIMILARITY_BAR_DEFAULT_TESTID
};
//# sourceMappingURL=index.es135.js.map
